import moment from 'moment'

const dateToIso = (date?: moment.MomentInput): string | null => {
    if (!date) {
        return null
    }

    return moment.parseZone(date).format()
}

export default dateToIso
